












































import { Component, Vue } from 'vue-property-decorator';
import DepartmentNewButton from '@/components/Department/DepartmentNewButton.vue';
import DepartmentShowButton from '@/components/Department/DepartmentShowButton.vue';
import DepartmentEditButton from '@/components/Department/DepartmentEditButton.vue';
import DepartmentDeleteButton from '@/components/Department/DepartmentDeleteButton.vue';
import { ALL_DEPARTMENTS } from '@/queries/Department';
import PermissionService from '@/utils/permission-service';

@Component({
  components: {
    DepartmentEditButton,
    DepartmentNewButton,
    DepartmentShowButton,
    DepartmentDeleteButton,
  },
})
export default class DepartmentList extends Vue {
  private ALL_DEPARTMENTS = ALL_DEPARTMENTS;
  private PermissionService = PermissionService;
}
